namespace Gordic.Adm.WebControls {
    export interface IGAdmSeznamOptions {
        content: GContent<GAdmSeznamBase>;
        contentName: string;
        contentCaption: string;
        dataListDescriptor: Gordic.General.ApplicationInterface.GDataListDescription;
        filterSettings?: {
            createFilter?: boolean,
            useHardDefaultFilter?: boolean,
            addDefaultaktivita?: boolean,
            favorites?: string[] | "all"
        }
        comparatorSettings?: {
            addComparator?: boolean,
            itemTemplate?: string,
        }
        gridSettings?: {
            columnOrder?: string, 
            defaultSort?: string,
            iconAktivitaColumns?: string[],
            profiles?: GridProfile<any>[]
        }
    }

    export const OptionsDefaults: IGAdmSeznamOptions = {
        content: $.content(),
        contentName: "",
        contentCaption: "",
        dataListDescriptor: {},
        filterSettings: {
            createFilter: true,
            useHardDefaultFilter: true,
            addDefaultaktivita: true,
            favorites: "all"
        },
        comparatorSettings: {
            addComparator: true,
            itemTemplate: "",
        },
        gridSettings: {
            columnOrder: "",
            defaultSort: "",
            iconAktivitaColumns: [],
            profiles: []
        }
    }

    export interface IGAdmGridSxs {
        sxs: string;
        nazev: string;
    }
}